
<div class="text-right">
    <button class="btn btn-outline-success" (click)="addSection()"><i class="fas fa-folder-plus mr-2"></i>Aggiungi sezione</button>
    <!-- <button [disabled]="!sections" class="btn btn-outline-success m-1" (click)="addField()"><i class="far fa-plus-square mr-2"></i>Aggiungi Campo</button>     -->
</div>
<ul class="nav nav-tabs mb-2">
    <li class="nav-item" *ngFor="let s of sections;let i=index">
        <a class="nav-link ID:{{s.id}}" [class.active]="tabsection==i" (click)="tabsection=i">
            <div class="text-truncate" style="max-width:5rem">{{s.label}}</div>
            <!-- <ng-container *ngIf="tabsection==i">
                <i title="Rinomina sezione" (click)="renameSection(s)"  class="text-secondary fas fa-pencil-alt ml-1"></i>
                <i title="Elimina sezione" (click)="deleteSection(s)"  class="text-danger fas fa-trash ml-1"></i>
            </ng-container> -->
        </a>
    </li>
</ul>
<div class="tab-content" id="myTabContent">
    <ng-container *ngIf="isArray(sections)">
        <div *ngFor="let s of sections;let j=index;" class="tab-pane fade show" [class.active]="tabsection==j" style="min-height:200px;">
            <div class="row mb-2">
                 <div class="col-lg-4">
                    <div class="">
                        <small>Etichetta sezione</small>
                        <input class="form-control form-control-sm" type="text" [(ngModel)]="s.label">
                    </div>
                </div>
                <div class="col-lg-4">
                    <small>Nome sezione</small>
                    <div class="input-group input-group-sm">
                        <input class="form-control form-control-sm" type="text" [(ngModel)]="s.name">
                        <div class="input-group-append input-group-append-sm">
                            <button class="btn btn-sm btn-default" title="Suggerisci/Correggi nome sezione" (click)="renameSection(s)"><i class="fas fa-magic"></i></button>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 text-right">
                    <button class="btn btn-outline-danger m-1" (click)="deleteSection(s)"><i class="fa fa-trash mr-2"></i>Elimina sezione</button>
                    <button class="btn btn-outline-success m-1" (click)="addField()"><i class="fa fa-plus mr-2"></i>Aggiungi campo</button>
                </div>
            </div>
            <ul class="list-group">
                <ng-container *ngIf="isArray(s.fields)">
                    <ng-container *ngFor="let f of s.fields;let i=index" >
                        <ng-container *ngIf="f.type!='section'">
                            <li class="list-group-item border mb-1" [class.border-danger]="f.access==0" [class.border-primary]="f['expand']">
                                <div class="row">
                                    <div class="col-lg-10 px-0">
                                        <app-field-setting 
                                        [f]="f"
                                        [i]="i"
                                        [j]="j" 
                                        [sections]="sections" 
                                        [fields]="s.fields"

                                        (onMoveToSection)="moveToSection($event)" 
                                            ></app-field-setting>
                                    </div>
                                    <div class="col-lg-2 pr-0 text-right">
                                        <small *ngIf="f.id" class="text-gray">ID: {{f.id}}</small><br>
                                        <button class="btn btn-default text-danger btn-xs" (click)="removeField(f)"><i class="fa fa-trash"  title="Elimina campo"></i></button>
                                        <button class="btn btn-default text-info btn-xs" (click)="duplicateField(f)"><i class="fa fa-clone"  title="Dupplica campo"></i></button>
                                        <button class="btn btn-default btn-xs" (click)="moveField(f,'up');"><i class="fas fa-chevron-up"  title="Sposta sopra"></i></button>
                                        <button class="btn btn-default btn-xs" (click)="moveField(f,'down');"><i class="fas fa-chevron-down"   title="Sposta sotto"></i></button>
                                        <button class="btn btn-default btn-xs" *ngIf="!f['expand']" (click)="f['expand']=true"><i class="fas fa-expand-alt"  title="Espandi"></i></button>
                                        <button class="btn btn-default btn-xs" *ngIf="f['expand']" (click)="f['expand']=false"><i class="fas fa-compress-alt"  title="Comprimi"></i></button>
                                    </div>
                                </div>
                            </li>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </ul>
        </div>
    </ng-container>

</div>